'use strict';

var react = require('@sentry/react');
var beforeBreadcrumb = require('./before-breadcrumb/beforeBreadcrumb.cjs');
var beforeSend = require('./beforeSend.cjs');
var transport = require('./transport.cjs');

const init = ({
  enabled,
  dsn,
  environment = "development",
  sampleRate = 0.01,
  ignoreErrors,
  denyUrls
}) => {
  if (!dsn) {
    return;
  }
  const integrations = [
    react.browserTracingIntegration(),
    react.extraErrorDataIntegration({ depth: 10 }),
    react.moduleMetadataIntegration()
  ];
  react.init({
    denyUrls,
    dsn,
    enabled,
    environment,
    ignoreErrors,
    integrations,
    tracesSampleRate: sampleRate,
    transport: transport.transport,
    beforeBreadcrumb: beforeBreadcrumb.beforeBreadcrumb,
    beforeSend: beforeSend.beforeSend
  });
};

exports.init = init;
//# sourceMappingURL=init.cjs.map
